import classes from './ShowcaseFooter.module.css';

const ShowcaseFooter: React.FC = () => {
  return <footer className={classes.footer}>© 2025 kalibri.shop</footer>;
};

export default ShowcaseFooter;
